import { Features } from "@/types/settings";
import { DataStatus } from "@/types/common";
import { PROCESSED_STATS_LIFETIME } from "@/config/series";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class GetPerServerProcessedStats extends Vue {
  @Getter("settings/activeCacheFeatures") features!: Features;
  @Getter("settings/activeCacheFeaturesStatus") featuresStatus!: DataStatus;

  intervalID = 0;

  // Use in created()
  getPerServerProcessedStats() {
    // Depends on features being fetched before being called, because `collect-granularity` defaults to 0,
    // meaning processed stats could not be fetched if fetching is attempted before features are fetched.
    // Features are first fetched in `views/cache/index.vue` before loading child views.
    if (this.features["collect-granularity"] === 0) {
      return;
    }

    this.$store.dispatch("processedStats/fetchPerServerPlotsByTimeRange");

    // Refetch data periodically
    this.intervalID = setInterval(() => {
      this.$store.dispatch("processedStats/fetchPerServerPlotsByTimeRange");
    }, PROCESSED_STATS_LIFETIME);
  }

  // Use in beforeDestroy()
  cleanUpPerServerProcessedStats() {
    if (this.features["collect-granularity"] === 0) {
      return;
    }

    clearInterval(this.intervalID);
  }
}
